import type {ReactElement} from 'react';
import {AiWriter} from '@Components/ai-writer';
import {AiWriterType} from '@Components/ai-writer/ai-writer.types';
import {useCaptionWriter} from '@Components/ai-writer/adapters/use-caption-writer';
import {PopoverDefaultAlignment} from '@Components/popover/popover.types';
import type {CaptionWriterPopoverViewProps} from './caption-writer-popover-view.types';

export function CaptionWriterPopoverView({isOpen, referenceElementRef, accountId, postId, onClose, onContentSelected}: CaptionWriterPopoverViewProps): ReactElement {
  const source = useCaptionWriter({accountId, postId, onContentSelected});

  return (
    <AiWriter
      displayType={AiWriterType.POPOVER}
      source={source}
      alignment={PopoverDefaultAlignment.RIGHT_CENTER}
      referenceElementRef={referenceElementRef}
      isOpen={isOpen}
      onClose={onClose}
      closeOnItemSelect
    />
  );
}
